module.exports = __webpack_public_path__ + "static/media/f6.a7d340e1.jpg";